import React from 'react'
import RouterLink from 'redux-first-router-link'
import cx from 'classnames'
import { useInternalState } from './hooks'
import { Icon } from 'components/shared/Icon/Icon'
import { ICON_SIZES, SIZE_SMALL } from './model'
import styles from './Link.module.scss'
import spinner from 'assets/icons/spinner.svg'

export const Link = ({
  className = undefined,
  color,
  icon,
  label,
  size,
  target,
  variant,
  to,
  filename,
  redirect = false,
  isContentReversed = false,
  isExternal = false,
}) => {
  const Component = isExternal ? 'button' : RouterLink

  const {
    state: { downloading },
    handlers: { handleDownload },
  } = useInternalState({ to, filename })

  return (
    <Component
      className={cx(styles.link, {
        [styles.size]: Boolean(size),
        [styles[size]]: Boolean(size),
        [styles.variant]: Boolean(variant),
        [styles[variant]]: Boolean(variant),
        [styles.color]: Boolean(color),
        [styles[color]]: Boolean(color),
        [styles.reversed]: isContentReversed,
        [className]: Boolean(className),
      })}
      {...(isExternal
        ? {
            onClick: downloading ? () => {} : handleDownload,
          }
        : { to, redirect })}
      {...{ target }}
    >
      {icon ? (
        <Icon
          className={cx(styles.icon, {
            [styles.nospacing]: !Boolean(label),
            [styles.hide]: downloading,
          })}
          icon={icon}
          size={ICON_SIZES[size]}
        />
      ) : null}
      {label ? (
        <span
          className={cx(styles.label, {
            [styles.nospacing]: !Boolean(icon),
            [styles.hide]: downloading,
          })}
        >
          {label}
        </span>
      ) : null}
      {downloading ? (
        <div className={cx(styles.spinnerContainer)}>
          <img
            src={spinner}
            className={cx(styles.spinner, {
              [styles.small]: size === SIZE_SMALL,
            })}
          />
        </div>
      ) : null}
    </Component>
  )
}
